import { useEffect } from 'react';
import { FormattedMessage } from 'react-intl';
import { useDispatch } from '_common/hooks';

import { setCurrentAppPage } from 'App/redux/appSlice';

import IntlErrorBoundary from '_common/components/IntlErrorBoundary/IntlErrorBoundary';
import Header from './Header';
import Table from './Table/Table';

import styles from './RecyclePage.module.scss';

const RecyclePage = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(setCurrentAppPage('/storage/recycle'));
  }, []);

  return (
    <div className={styles.root}>
      <div className={styles.header}>
        <IntlErrorBoundary size="s" style={{ margin: '0 0 0 7rem' }}>
          <Header />
        </IntlErrorBoundary>
      </div>
      <div className={styles.message}>
        <FormattedMessage id="storage.browserHeader.recycleDesc" />
      </div>
      <div className={styles.content}>
        <div className={styles.tableWrapper}>
          <Table />
        </div>
      </div>
    </div>
  );
};

export default RecyclePage;
